export default __webpack_public_path__ + "img/bodvHFJI.fe705854.svg";